import { IconType } from './Icon.constants';
export function getSvgIconExportSuffix(folderName) {
  switch (folderName) {
    case IconType.REGULAR:
      return '';
    case IconType.TYPE_30:
      return IconType.TYPE_30;
    case IconType.COLOR:
      return IconType.COLOR;
    default:
      throw new Error(`Incorrect folder name: '${folderName}'`);
  }
}
const ICON_TYPE_REGEXP = new RegExp(`(${Object.values(IconType).filter(iconType => iconType !== IconType.REGULAR).join('|')})$`);
function isValidIconType(iconTypeString) {
  return Object.values(IconType).includes(iconTypeString);
}
export function getIconType(iconName) {
  const iconTypeMatch = iconName.match(ICON_TYPE_REGEXP);
  if (iconTypeMatch !== null) {
    const [iconType] = iconTypeMatch;
    if (isValidIconType(iconType)) {
      return iconType;
    }
  }
  return IconType.REGULAR;
}